export const type = 'ECD/AddEvent';

export default (page, { category, label, action }) => ({
  type,
  payload: { category, label, action },
  meta: { page },
});
